import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import type { RootState, AppThunkDispatch } from './store'

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
export const useAppDispatch = (): AppThunkDispatch => useDispatch<AppThunkDispatch>();
